(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('CopyrightSearch', CopyrightSearch);

    CopyrightSearch.$inject = ['$resource'];

    function CopyrightSearch($resource) {
        var resourceUrl =  'api/_search/copyrights/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
